import { theme } from 'common/theme';

export const STYLES_FOR_PDF = `
.pdfTable {
    border-collapse: collapse;
}
.tableRow {
    border: 1px solid ${theme.highlighted.grey};
}
th {
    background-color: ${theme.primary.main};
    font-size: 10px;
}
td {
    border-right: 1px solid ${theme.highlighted.grey};
    text-align: left;
    font-size: 10px;
    padding-left: 5px;
}
.grpHeader {
    font-weight: bold;
    font-size: 18px;
    background: ${theme.secondary.light};
    color: ${theme.white.light};
    text-align: center;
}
.narrative {
    background: ${theme.white.dark};
}
.totals {
    font-weight: bold;
    text-align: center;
}
.timeKeeper {
    font-size: 15px;
    background: ${theme.white.light};
    font-weight: 400;
    text-align: left;
}
.timeKeeperR, .timeKeeperH {
    height: 0 !important;
}
.dateRange {
    padding-bottom: 5px !important;
}
body{
    -webkit-print-color-adjust: exact;
    display: block;
    width: 100%;
    height: 100%;
    font-family: 'Roboto', sans-serif;
}
@page { 
    size: auto;
    @bottom-left {
        content: counter(page);
    }
    margin-left: 25px;
}
`